<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    bars: number[]
    playing?: boolean
    barClass?: string
  }>(),
  { playing: true, barClass: 'bg-primary/55' },
)

// Stagger per bar so the waveform ripples instead of pulsing as one block
const delays = computed(() => props.bars.map((_, index) => `${(index % 12) * 70}ms`))
</script>

<template>
  <div class="flex items-end gap-[3px]" :class="playing ? '' : 'motion-paused'" aria-hidden="true">
    <span
      v-for="(height, index) in bars"
      :key="index"
      class="motion-wave w-[3px] rounded-full"
      :class="barClass"
      :style="{ height: `${height}px`, animationDelay: delays[index] }"
    ></span>
  </div>
</template>
